document.addEventListener('DOMContentLoaded', function() {
    const openingHoursTitles = document.querySelectorAll('.opening-hours-title:not(.fixed .opening-hours-title)');
    openingHoursTitles.forEach(title => {
        title.addEventListener('click', function() {
            const parent = title.parentElement;
            const openingHours = parent.querySelector('.opening-hours');
            title.classList.toggle('active');
            if (title.classList.contains('active')) {
                window.anime({
                    targets: openingHours,
                    height: ['0px', openingHours.scrollHeight + 'px'],
                    duration: 250,
                    easing: 'easeInOutQuad'
                });
            } else {
                window.anime({
                    targets: openingHours,
                    height: [openingHours.scrollHeight + 'px', '0px'],
                    duration: 250,
                    easing: 'easeInOutQuad'
                });
            }
        });
    });

    const openClosedElements = document.querySelectorAll('.wp-block-klx-location:not(.fixed');
    openClosedElements.forEach(element => {
        const jsonLdScript = element.querySelector('script[type="application/ld+json"]');
        if (jsonLdScript) {
            const eleToChange = element.querySelector('.open-closed')
            const jsonLdData = JSON.parse(jsonLdScript.textContent);
            const currentDayOfWeek_en = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
            var foundEntry = false;
            var nearestOpeningHours = [];
            const currentTime = new Date().getHours();

            jsonLdData.openingHoursSpecification.forEach(oh => {
                const opens = parseInt(oh.opens.split(':')[0]);
                const closes = parseInt(oh.closes.split(':')[0]);
                if(oh.dayOfWeek.toLowerCase() === currentDayOfWeek_en) {
                    if(currentTime >= opens && currentTime < closes) {
                        eleToChange.classList.add('is-open');
                        const timeLeft = closes - currentTime;
                        if(timeLeft <= 1) {
                            eleToChange.querySelector('.text').textContent = `geöffnet schließt aber bald`;
                        } else {
                            eleToChange.querySelector('.text').textContent = `geöffnet - schließt in ca. ${timeLeft} Stunden`;
                        }
                        foundEntry = true;
                        return;
                    } else {
                        nearestOpeningHours.push(oh);
                    }
                } else {
                    nearestOpeningHours.push(oh);
                }
            });
            if(!foundEntry) {
                if(nearestOpeningHours.length > 0) {
                    var _oh = nearestOpeningHours[0];
                    const opens = parseInt(_oh.opens.split(':')[0]);
                    const timeLeft = opens - currentTime - 1;
                    if(timeLeft <= 1) {
                        eleToChange.classList.add('is-closed');
                        eleToChange.querySelector('.text').textContent = `geschlossen - öffnet bald`;
                    } else {
                        eleToChange.classList.add('is-closed');
                        eleToChange.querySelector('.text').textContent = `geschlossen - öffnet in ca. ${timeLeft} Stunden`;
                    }
                } else {
                    eleToChange.classList.add('is-closed');
                    eleToChange.querySelector('.text').textContent = 'geschlossen';
                }
            }
        }
    });
});

